import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import BuildIcon from '@mui/icons-material/Build';
import { Dictionary } from '../../../Components/Common/CommonModel';

export const tenantStateIcons: Dictionary<React.JSX.Element> = {
  1: <CheckCircleIcon style={{ color: 'green' }} />,
  2: <InfoIcon style={{ color: 'blue' }} />,
  3: <WarningIcon style={{ color: 'orange' }} />,
  4: <ErrorIcon style={{ color: 'red' }} />,
  5: <CheckCircleIcon style={{ color: 'green' }} />,
  6: <BuildIcon style={{ color: 'gray' }} />,
};
